const data_deal_step = {
  1: {
    stepDeal: 1,
    stepIntermediate: 0,
    value: '"(1,0)"',
    en: 'Commercial',
    fr: 'Commercial',
  },
  2: {
    stepDeal: 1,
    stepIntermediate: 1,
    value: '"(1,1)"',
    en: 'Commercial-proposition',
    fr: 'Commercial-proposition',
  },
  3: {
    stepDeal: 1,
    stepIntermediate: 2,
    value: '"(1,2)"',
    en: 'Commercial-BDC',
    fr: 'Commercial-BDC',
  },
  4: {
    stepDeal: 2,
    stepIntermediate: 0,
    value: '"(2,0)"',
    en: 'Production',
    fr: 'Production',
  },
  5: {
    stepDeal: 2,
    stepIntermediate: 1,
    value: '"(2,1)"',
    en: 'Production-order',
    fr: 'Production-commande',
  },
  6: {
    stepDeal: 2,
    stepIntermediate: 2,
    value: '"(2,2)"',
    en: 'Production-packing',
    fr: 'Production-preparation',
  },
  7: {
    stepDeal: 2,
    stepIntermediate: 3,
    value: '"(2,3)"',
    en: 'Production-installation',
    fr: 'Production-installation',
  },
  8: {
    stepDeal: 3,
    stepIntermediate: 0,
    value: '"(3,0)"',
    en: 'Administratif',
    fr: 'Administratif',
  },
  9: {
    stepDeal: 3,
    stepIntermediate: 1,
    value: '"(3,1)"',
    en: 'Administratif-TB',
    fr: 'Administratif-AF',
  },
  10: {
    stepDeal: 3,
    stepIntermediate: 2,
    value: '"(3,2)"',
    en: 'Administratif-PB',
    fr: 'Administratif-PF',
  },
};

export default data_deal_step;
